const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M39.6%2010.2002L13.8%2020.3002L0%2010.2002H39.6Z'%20fill='%23004A99'/%3e%3cpath%20d='M39.9998%2010.2002L29.4998%2031.8002L13.7998%2020.3002L39.5998%2010.2002H39.9998Z'%20fill='%23008FCB'/%3e%3c/svg%3e";
export {
  e as default
};
